import { render } from "./InfiniteCarousel.vue?vue&type=template&id=05c8c1e8"
import script from "./InfiniteCarousel.vue?vue&type=script&lang=js"
export * from "./InfiniteCarousel.vue?vue&type=script&lang=js"

import "./InfiniteCarousel.vue?vue&type=style&index=0&id=05c8c1e8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__